var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLang({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_841",
    "data-name": "\\uADF8\\uB8F9 841",
    transform: "translate(-1645 37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_264",
    "data-name": "\\uD0C0\\uC6D0 264",
    transform: "translate(1645 -37)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_265",
    "data-name": "\\uD0C0\\uC6D0 265",
    transform: "translate(1647 -37)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3,
    cy: 5,
    rx: 3,
    ry: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3,
    cy: 5,
    rx: 2.5,
    ry: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_14",
    "data-name": "\\uD328\\uC2A4 14",
    d: "M1650-37v10",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_15",
    "data-name": "\\uD328\\uC2A4 15",
    d: "M1650-37v10",
    transform: "translate(1618 -1682) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLang);
export default __webpack_public_path__ + "static/media/lang.7c960dceb4cee2f862cf8237fdea9ad8.svg";
export { ForwardRef as ReactComponent };